export const RECENTLY_WATCHED_LISTING_IDS = 'recentlyWatchedListingIds'
export const RECENTLY_WATCHED_SHOP_IDS = 'recentlyWatchedShopIds'
export const WISHLIST_IDS = 'wishlistIds'
export const SHARED_LISTING_IDS = 'sharedListingIds'
export const REPORTED_USER_IDS = 'reportedUserIds'
export const ORDER_VERIFICATIONS = 'orderVerifications'
